import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthInterceptadorService} from "./auth-interceptador.service";
import {ErrorInterceptadorService} from "./error-interceptador.service";

export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptadorService,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptadorService,
    multi: true
  }
];
